module.exports = __webpack_public_path__ + "img/image-fill.795324c1.svg";